import React from 'react'
import { useGetOperationList } from '../../../hooks/useGetOperationList'
import { Table } from 'ui'
import { useIntl } from 'react-intl'
type Props = {
   currentValues: any
   onPageChange: (p: any) => any
   onSortChange: (p: any) => any
   columns: any
   children?: React.ReactNode
   defaultProgram?: number
   defaultQuery?: string
   contanierClassName?: string
   showPointsHelp?: boolean
}
export default function TableOperations(props: Props) {
      const intl = useIntl()
   const { currentValues, onPageChange, columns, onSortChange, children, defaultQuery, contanierClassName, showPointsHelp } = props
const { sort }=currentValues
   const { data: operationList, status } = useGetOperationList({
      ...currentValues,
      ...(defaultQuery && {
         query: defaultQuery,
      }),
   })
   return (
      <>
         <Table
         key={JSON.stringify(currentValues)}
            fetching={status === 'pending'}
            columns={columns}
            data={operationList?.items ?? []}
            containerClassName={contanierClassName}
            tableClassName="border-y sss"
            footerClassName="px-4"
            showTableResume
            pagination={{
               defaultPageSize: currentValues.size,
               defaultPageIndex: currentValues.page,
               totalSize: operationList?.totalSize ?? 0,
               onPageChange: onPageChange,
            }}
            sorting={{
               sorting:
                  sort && sort.length
                     ? [{ id: sort?.split(',')[0], desc: sort?.split(',')[1] === 'desc'}]
                     : null,
               onSortChange: onSortChange,
            }}
         >
            {children}
         </Table>
         {showPointsHelp && (
            <small className='text-gray-500 ml-3'>
               {intl.formatMessage({
                  id:'operations.table.helptext.expired-points'
               })}
            </small>
         )}
         </>
   )
}
